import {Injectable} from "@angular/core";


import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

import {environment} from "@env/environment";
import {PackageModel} from "@app/@core/domain/package.model";
import Package = PackageModel.PackageInfo;
import PackageStatus = PackageModel.PackageStatus;
import {map} from "rxjs/operators";
import {orderBy} from "lodash-es";
import {CourseOption} from "@app/@core/repositories/course.repository";
import PackageAllResponse = PackageModel.PackageAllResponse;
import PackageInfoStatus = PackageModel.PackageInfoStatus;
import Item = PackageModel.Item;
import {ShopOption} from "@app/@core/repositories/leisure-shop.repository";


export interface PackageInfoOption {
  label: string;
  value: string;
  status: PackageInfoStatus;
}

@Injectable({
  providedIn: 'root'
})
export class PackageInfoRepository {
  protected baseURL = environment.api3Url;
  protected path = '/api/internal/package-info';

  constructor(protected http: HttpClient) {

  }

  getPackageAll(): Observable<PackageAllResponse[]> {
    return this.http.get<PackageAllResponse[]>(`${this.baseURL + this.path}/all`);
  }
  getPackageAllByShopId(shopId: string): Observable<PackageAllResponse[]> {
    return this.http.get<PackageAllResponse[]>(`${this.baseURL + this.path}/all/by-shop/${shopId}`);
  }

  getPackageAllList(): Observable<PackageModel.PackageInfo[]> {
    return this.http.get<PackageModel.PackageInfo[]>(`${this.baseURL + this.path}/all-list`);
  }

  getPackageList(): Observable<PackageModel.PackageListResponse[]> {
    return this.http.get<PackageModel.PackageListResponse[]>(`${this.baseURL + this.path}/list`);
  }

  getPackageById(id: string): Observable<Package> {
    return this.http.get<Package>(`${this.baseURL + this.path}/${id}`);
  }

  createPackage(model: Package): Observable<Package> {
    return this.http.post<Package>(`${this.baseURL + this.path}`, model);
  }

  editPackageById(id: string, model: Package): Observable<Package> {
    return this.http.put<Package>(`${this.baseURL + this.path}/${id}`, model);
  }

  deletePackageById(id: string): Observable<Package> {
    return this.http.delete<Package>(`${this.baseURL + this.path}/${id}`);
  }

  getPackageByShopId(shopId: string): Observable<Package[]> {
    return this.http.get<Package[]>(`${this.baseURL + this.path}/by-shop/${shopId}`);
  }


  getOptionShop(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseURL}/api/internal/package-info/shop-search`);
  }

  fetchNames(): Observable<ShopOption[]> {
    return this.http.get<any[]>(`${this.baseURL}/api/internal/package-info/shop-search`).pipe(
      map(list => list.map(m => ({
        value: m.id,
        label: m.name,
        status: m.status
      }))),
      map(list => orderBy((list), 'label'))
    );
  }

  createPackageItem(packageId: string, model: Item): Observable<Item> {
    return this.http.post<Item>(`${this.baseURL}/api/internal/package-info/${packageId}/item`, model).pipe(
    );
  }

  deletePackageItem(packageId: string, packageItemId: string): Observable<Item> {
    return this.http.delete<Item>(`${this.baseURL}/api/internal/package-info/${packageId}/item?packageItemId=${packageItemId}`).pipe(
    );
  }

}
